import { takeLatest, put, select } from 'redux-saga/effects';
import { get } from 'lodash';
// import update from 'immutability-helper';
// import { dimensionsListSelector } from '@store/common/dimensionList/selectors';

import * as actions from './actions';
import * as types from './types';
import selector from './selectors';
import { fetchData } from '../historicalRangeData/actions';

// import { filterPersistedData } from './utils';

function* initBase(action) {
  // persistence action is common
  // ignore if triggered from another tab
  const key = get(action, ['response', 'key'], null);
  const { meta = {} } = action;

  if (key !== '/metriclens') {
    return;
  }
  const persistedML = get(action, ['response', 'configuration', 'ml'], {});

  yield put(actions.updateBase(persistedML));
  yield put(fetchData());

  if ('doneCallback' in meta) {
    meta.doneCallback();
  }
}

function* triggerPersistence() {
  const baseState = yield select(selector);
  yield put(actions.persistState({ ml: baseState }));
}

function* watchPersistedState() {
  yield takeLatest([types.UPDATE_PERSISTED_ML_STATE], initBase);
}

// actions to watch for persistence
function* watchActions() {
  yield takeLatest(
    [
      types.SET_SELECTED_METRICS,
      types.SET_SELECTED_DIMENSION,
      types.SET_SELECTED_FILTERS,
      types.SET_APPLIED_SORT,
      types.SET_SELECTED_INTERVAL,
      types.REMOVE_APPLIED_FILTER,
      types.SET_SELECTED_GRANULARITY,
      types.SET_TIMESERIES_MODE,
      types.SET_UNIT_MODE,
      types.SET_SELECTED_SHORTCUT,
      types.SET_LIVE_MODE,
    ],
    triggerPersistence,
  );
}

export default [watchPersistedState, watchActions];
